import { gql } from "@apollo/client";

const REPORT_ERROR_MESSAGE = gql`
  mutation reportingErrorMessage($input: [errorreport_insertion_data!]) {
    reportingErrorMessage(input: $input) {
      success
      error
    }
  }
`;

export default REPORT_ERROR_MESSAGE;
